import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero: React.FC = () => {
  const verticals = [
    {
      id: 'real-estate',
      title: 'Real Estate',
      description: 'Premium property development and investment opportunities across Nepal',
      image: '/images/real_estate.jpg',
      isLarge: true,
      link: '/real-estate'
    },
    {
      id: 'hospitality',
      title: 'Hospitality',
      description: 'Luxury hotels and world-class hospitality services',
      image: '/images/bagaincha.jpeg',
      isLarge: true,
      link: '/hospitality'
    },
    {
      id: 'malls',
      title: 'Commercial',
      description: 'Modern shopping centers and retail destinations',
      image: '/images/mall.jpeg',
      isLarge: true,
      link: '/commercial'
    },
    {
      id: 'automobile',
      title: 'Automobile',
      description: 'Premium automotive services and dealerships',
      image: '/images/automobile.jpg',
      isLarge: false,
      link: '/automobile'
    },
    {
      id: 'banking_finance',
      title: 'Banking & Finance',
      description: 'Banking and financial services.',
      image: '/images/banking.webp',
      isLarge: false,
      link: '/banking_finance'
    },
    {
      id: 'agriculture',
      title: 'Agriculture',
      description: 'Agro farms and agriculture services.',
      image: '/images/agriculture.jpg',
      isLarge: false,
      link: '/agriculture'
    }
  ];

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="verticals-grid">
          {verticals.map((vertical, index) => (
            <motion.div
              key={vertical.id}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`vertical-card ${vertical.isLarge ? 'large' : 'small'}`}
            >
              <Link to={vertical.link} className="vertical-link">
                <div 
                  className="vertical-background"
                  style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${vertical.image})` }}
                >
                  <div className="vertical-overlay">
                    <motion.div
                      className="vertical-content"
                      whileHover={{ y: -10 }}
                      transition={{ duration: 0.3 }}
                    >
                      <h3 className="vertical-title">{vertical.title}</h3>
                      <p className="vertical-description">
                        {vertical.description}
                      </p>
                    </motion.div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero; 